import * as assetValues from "@app/assets/assets";
import { extractViewBox } from "@app/utils/svg";
import { SVGAttributes, useLayoutEffect, useState } from "react";
import { cn } from "@shortsworks/ui/lib/utils";

export type AssetType = keyof typeof assetValues;

interface AssetImporterProps extends SVGAttributes<SVGElement> {
  name: AssetType;
  classNme?: string;
}

export const AssetImporter = ({
  name,
  className,
  ...rest
}: AssetImporterProps) => {
  const [innerHTML, setInnerHTML] = useState("");
  const [viewBox, setViewBox] = useState("0 0 16 16");

  useLayoutEffect(() => {
    const asset = assetValues[name];
    const viewBox = extractViewBox(asset);
    const innerText = asset.replace(/<svg ([^>]*)>/, "").replace("</svg>", "");

    setViewBox(viewBox);
    setInnerHTML(innerText);
  }, [name]);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={cn("align-middle", className)}
      viewBox={viewBox}
      dangerouslySetInnerHTML={{
        __html: innerHTML,
      }}
      {...rest}
    ></svg>
  );
};
